const D = {
	LANG: 'en',
	LANGS: ['en'],
	DEFAULT_LANG: 'en',
	DEV: '',
	ID: 0,
	UPL: '',
	VUPL: '',
	PRICE: {},
	FB_APP_ID: '',
	URL: '',
	URL_B2C: '',
	URL_B2B: '',
	SESSION_DISCOUNT: '',
	SESSION_INVITE_EMAIL: '',
	HAS_TEAM: false,
	EVENT: {},
	MIN_AFFILIATE: 1000,
	AFFILIATE_ENABLED: false,
	AFFILIATE_DISCOUNT: false,
	BRAINTREE_3DS_ENABLED: false,
	DS: '',
	QUOTES: [],
	CASE_STUDIES: [],
	OS: '',
	BROWSER: '',
	SESSION_DISCOUNT_AMOUNT: '',
	FOOTER: {
		links: [],
		info: {
			title: '',
			text: ''
		},
		contacts: {
			href: '',
			text: ''
		},
		copyright: {
			text: ''
		},
		liaa: ''
	},
	OG: {},
	APP_WEBVIEW: false,
	me: {
		id: 0,
		name: '',
		hasAdminAccess: false
	},
	v: 0,
	SITE_B2B: false,
	SITE_B2C: false,
	SITE: '',

	callingCodes: ["1", "1242", "1246", "1264", "1268", "1284", "1340", "1345", "1441", "1473", "1649", "1664", "1670", "1671", "1684", "1721", "1758", "1767", "1784", "1787", "1809", "1829", "1849", "1868", "1869", "1876", "1939", "20", "211", "212", "213", "216", "218", "220", "221", "222", "223", "224", "225", "226", "227", "228", "229", "230", "231", "232", "233", "234", "235", "236", "237", "238", "239", "240", "241", "242", "243", "244", "245", "246", "247", "248", "249", "250", "251", "252", "253", "254", "255", "256", "257", "258", "260", "261", "262", "263", "264", "265", "266", "267", "268", "269", "27", "290", "291", "297", "298", "299", "30", "31", "32", "33", "34", "350", "351", "352", "353", "354", "355", "356", "357", "358", "359", "36", "370", "371", "372", "373", "374", "375", "376", "377", "378", "379", "380", "381", "382", "383", "385", "386", "387", "389", "39", "40", "41", "420", "421", "423", "43", "44", "45", "46", "47", "4779", "48", "49", "500", "501", "502", "503", "504", "505", "506", "507", "508", "509", "51", "52", "53", "54", "55", "56", "57", "58", "590", "591", "592", "593", "594", "595", "596", "597", "598", "599", "5999", "60", "61", "62", "63", "64", "65", "66", "670", "672", "673", "674", "675", "676", "677", "678", "679", "680", "681", "682", "683", "685", "686", "687", "688", "689", "690", "691", "692", "7", "81", "82", "84", "850", "852", "853", "855", "856", "86", "880", "886", "90", "91", "92", "93", "94", "95", "960", "961", "962", "963", "964", "965", "966", "967", "968", "970", "971", "972", "973", "974", "975", "976", "977", "98", "992", "993", "994", "995", "996", "998"],

	doNothing: function () {
	},

	init: function () {
		let header = document.getElementById('header-wrapper');
		if (header) {
			new D.StickyHeader(header);
		}

		D.initDropdownMenu();

		if (D.ID) {
			setInterval(function () {
				fetch('/keepalive.php');
			}, 600000);

			let get = new Get();
			if (get.is('auth')) {
				D.gtag('login', {
					ecommerce: {
						method: get.v('auth')
					}
				});
				D.branch('LOGIN', {
					"description": "Login from " + get.v('auth'),
					"user_id": D.ID
				});
			}
		}
	},

	loadingOverlay: function (node, par) {
		par = par || {};
		if (typeof node === 'string') {
			node = document.getElementById(node);
		}
		if (!node) {
			D.console.error('D.loadOverlay( node ) - not element');
			return false;
		}
		if (node._drOverlay) {
			node._drOverlay.remove();
		}
		if (getStyle(node, 'position') === 'static') {
			node.style.position = 'relative';
		}
		let overlay = node._drOverlay = mkE({
			tag: 'div',
			className: 'rqOverlay',
			style: {
				height: 'auto',
				width: 'auto',
				bottom: '0px',
				right: '0px'
			}
		}).append(node);
		if (par.delay) {
			addClassName(overlay, 'delay');
		}
		setTimeout(function () {
			addClassName(overlay, 'fadeIn');
		}, 1);
		if (par.loadingText) {
			setTimeout(D.closure(this, function () {
				if (node._drOverlay) {
					mkE({
						tag: 'div',
						className: 'rqLoadingText',
						text: par.loadingText
					}).append(overlay);
				}
			}), 2000);
		}
		if (par.backgroundPosition) {
			overlay.style.backgroundPosition = par.backgroundPosition;
		} else if (overlay.offsetHeight > 400) {
			overlay.style.backgroundAttachmentX = 'fixed';
		}
		setTimeout(function () {
			let q = $(overlay);
			if (!q.closest('body')[0]) {
				return;
			}
			q.animate({opacity: 0.9}, 6000);
		}, 2000);
		return overlay;
	},

	removeLoadingOverlay: function (node) {
		if (typeof node === 'string') {
			node = document.getElementById(node);
		}
		if (!node) {
			D.console.error('D.removeLoadOverlay( node ) - not element');
			return false;
		}
		if (node._drOverlay) {
			node._drOverlay.remove();
			return true;
		}
		return false;
	},

	position: function (el, parent) {
		let re = {
			left: findPosX(el, parent),
			top: findPosY(el, parent)
		};
		re.x = re.left + $(document).scrollLeft();
		re.y = re.top + $(document).scrollTop();
		return re;
	},

	rootDomain: function (url) {
		let a = url;
		try {
			if (url.nodeType !== Node.ELEMENT_NODE) {
				a = mkE({
					tag: 'a',
					href: url
				});
			}
			if (a.host.match(/^[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}$/)) {
				return a.host;
			}
			let parts = a.host.split('.');
			if (!parts[1]) {
				return a.host
			}
			parts.splice(0, parts.length - 2);
			return parts.join('.');
		} catch (e) {
			D.console.error(e);
		}
		return '';
	},

	/**
	 * @param {Event} e
	 * @return {Event}
	 */
	event: function (e) {
		e = e || window.event;
		if (!e) {
			return e;
		}
		if (typeof e.layerX === 'undefined') {
			e.layerX = e.offsetX;
			e.layerY = e.offsetY;
		}
		if (typeof e.target === 'undefined') {
			e.target = e.srcElement;
		}
		return e;
	},

	url: function (url, lang = null, full = false, isB2C = null) {
		let parts = url.split('?', 2);
		url = parts[0].replace(/^\/+|\/+$/g, '');
		let urlParts = url.split('/');
		let currentLang = reset(urlParts);
		if (!in_array(currentLang, D.LANGS)) {
			currentLang = D.LANG;
		} else {
			urlParts.shift();
		}
		currentLang = lang || currentLang;
		let domain = D.URL;
		if (isB2C === true) {
			domain = D.URL_B2C;
		} else if (isB2C === false) {
			domain = D.URL_B2B;
		}
		let re = (full === true ? domain : '/') + currentLang;
		if (urlParts.join('/')) {
			re += '/' + urlParts.join('/');
		}
		if (D.APP_WEBVIEW && parts[1]) {
			parts[1] = 'app-webview&' + parts[1];
		} else if (D.APP_WEBVIEW) {
			parts[1] = 'app-webview';
		}
		return re + (parts[1] ? '?' + parts[1] : '');
	},

	/**
	 * @param {string} src
	 * @param {Function} [callback]
	 * @param {Object} [par]
	 * @returns {boolean}
	 */
	addJS: function (src, callback, par) {
		callback = callback || false;
		par = par || {};
		par.context = par.context || document;
		par.async = (isset(par.async) ? par.async : true);
		let head = getHeadElement(par.context);
		let differentOrigin = false;
		let path = function () {
			if ((src[0] === '/' && src[1] === '/') || src[4] === ':' || src[5] === ':') {
				return src;
			}
			if (src[0] === '/') {
				src = src.substr(1);
			}
			differentOrigin = !D.DEV;
			if (D.DEV) {
				return '/' + src;
			}
			return '/' + src;
		};
		let s = path();
		let scripts = head.getElementsByTagName('script');
		for (let i = 0; i < scripts.length; ++i) {
			let script = scripts[i];
			if (!script.src) {
				continue;
			}
			let ix = script.src.indexOf(s);
			if (ix === -1) {
				continue;
			}
			if (script.src.length === ix + s.length) {
				if (script.onload !== null) {
					script.addEventListener('load', callback, {once: true});
					return;
				}
				if (callback && typeof (callback) === 'function') {
					callback();
				}
				return false;
			}
		}
		let prop = {};
		if (typeof (callback) === 'function') {
			let ready = false;
			prop.onload = prop.onreadystatechange = function () {
				if (!ready && (!this.readyState ||
					this.readyState === 'loaded' || this.readyState === 'complete')) {
					ready = true;
					callback();
					this.onload = null;
					this.onreadystatechange = null;
				}
			};
		}
		let attr = {
			type: 'text/javascript',
			charset: 'utf-8',
			src: s,
			async: par.async
		};
		if (differentOrigin) {
			attr.crossorigin = 'anonymous';
		}
		mkE({
			tag: 'script',
			attr: attr,
			prop: prop
		}).append(head);

		return true;
	},

	/**
	 * @param {string} src
	 * @param {Function} [callback]
	 * @param {Object} [par]
	 */
	addCSS: function(src, callback, par) {
		callback = callback || false;
		par = par || {};
		par.context = par.context || document;
		const head = getHeadElement(par.context);
		const path = function(src) {
			if ((src[0] === '/' && src[1] === '/') || src[4] === ':' || src[5] === ':') {
				return src;
			}
			if (src[0] === '/') {
				src = src.substr(1);
			}
			return location.origin + '/' + src;
		};
		const s = path(src);
		const links = head.getElementsByTagName('link');
		for (let i = 0; i < links.length; ++i) {
			let link = links[i];
			if (link.type === 'text/css' && link.href.indexOf(s) === 0) {
				if (callback && typeof (callback) === 'function') {
					callback();
				}
				return;
			}
		}
		let prop = {};
		if (typeof (callback) === 'function') {
			let ready = false;
			prop.onload = prop.onreadystatechange = function() {
				if (!ready && (!this.readyState ||
					this.readyState === 'loaded' || this.readyState === 'complete')) {
					ready = true;
					callback();
					this.onload = null;
					this.onreadystatechange = null;
				}
			};
		}
		mkE({
			tag: 'link',
			attr: {
				type: 'text/css',
				rel: 'stylesheet',
				href: s
			},
			prop: prop
		}).append(head);
	},

	reload: function (noParent) {
		let doc;
		if (window.parent && window.parent !== window && noParent !== true) {
			doc = window.parent.document;
		} else {
			doc = document;
		}
		doc.location.reload();
		return false;
	},

	/**
	 * @param {Node} node
	 * @param {RegExp} pattern
	 * @param {function} callback
	 * @param {Object} [par]
	 */
	replaceWithNode: function (node, pattern, callback, par) {
		par = par || {};
		if (!pattern.global) {
			D.console.error(pattern, ' require global RegExp');
			return;
		}
		if (node.nodeType === Node.ELEMENT_NODE) {
			let childs = [];
			for (let i = 0; i < node.childNodes.length; ++i) {
				childs.push(node.childNodes[i]);
			}
			for (let i = 0; i < childs.length; ++i) {
				if (childs[i].nodeType === Node.ELEMENT_NODE && par.ignoreLinks && childs[i].tagName === 'A') {
					continue;
				}
				this.replaceWithNode(childs[i], pattern, callback, par);
			}
			return;
		}
		if (node.nodeType !== Node.TEXT_NODE) {
			return;
		}

		let match = false;
		let text = node.nodeValue;
		pattern.lastIndex = 0;
		let ta = [];
		let start = 0;
		let m;
		while ((m = pattern.exec(text)) !== null) {
			let sub = text.substr(start, pattern.lastIndex - start - m[0].length);
			ta.push(sub);
			start = pattern.lastIndex;
			ta.push(callback(m));
			match = true;
		}
		let sub = text.substr(start, text.length - start);
		ta.push(sub);
		if (!match) {
			return;
		}
		for (let i = 0; i < ta.length; ++i) {
			let v = ta[i];
			if (!v) {
				continue;
			}
			this._replaceInsertBefore(v, node);
		}
		removeNode(node);
	},

	_replaceInsertBefore: function (el, before) {
		if (typeof el == 'string') {
			let textNode = document.createTextNode(el);
			D.insertBefore(textNode, before);
			return;
		}
		if (is_array(el)) {
			for (let i = 0, l = el.length; i < l; i++) {
				let v = el[i];
				if (!v) {
					continue;
				}
				this._replaceInsertBefore(v, before);
			}
			return;
		}
		D.insertBefore(el, before);
	},

	stopPropagation: function (e) {
		e = e || window.event;
		if (!e) {
			return e;
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.cancelBubble = true;
		return e;
	},

	enableCookies: function () {
		new RPC('/api/web_rpc.php').send('enableCookies', {}, function () {
			D.reload();
		});
	},

	disableCookies: function (callback) {
		new RPC('/api/web_rpc.php').send('disableCookies', {}, function () {
			D.reload();
		});
	},

	hasConsent() {
		return true;
	},

	cookiesSettings: function () {
		D._cookies = {
			popup: null,
			checkboxes: {}
		};
		D._cookies.popup = new T.Popup({
			className: 'popup-cookies cookies-popup'
		});
		D._cookies.popup.setTitle(mkE({
			tag: 'div',
			className: 'cookies-popup-title',
			text: D.Lang.get('home.cookies.title')
		}));
		D._cookies.popup.setContent(mkE({
			tag: 'div',
			className: 'cookies-popup-window',
			els: [
				{
					tag: 'p',
					className: 'cookies-popup-description',
					text: D.Lang.get('home.cookies.description')
				},
				{
					tag: 'div',
					className: 'cookies-popup-items',
					els: [
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								new T.Form.CheckBox({
									checked: true,
									disabled: true,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.mandatory.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.mandatory.description')
								}
							]
						},
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								D._cookies.checkboxes.preferences = new T.Form.CheckBox({
									checked: D.COOKIES.preferences,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.preferences.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.preferences.description')
								}
							]
						},
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								D._cookies.checkboxes.statistics = new T.Form.CheckBox({
									checked: D.COOKIES.statistics,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.statistics.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.statistics.description')
								}
							]
						},
						{
							tag: 'div',
							className: 'cookies-popup-item',
							els: [
								D._cookies.checkboxes.marketing = new T.Form.CheckBox({
									checked: D.COOKIES.marketing,
									caption: mkE({
										tag: 'span',
										text: D.Lang.get('home.cookies.boxes.marketing.title')
									})
								}),
								{
									tag: 'p',
									text: D.Lang.get('home.cookies.boxes.marketing.description')
								}
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'cookies-popup-bottom',
					els: [
						{
							tag: 'a',
							href: D.url('/cookies-policy'),
							target: '_blank',
							text: D.Lang.get('home.cookies.policy')
						},
						{
							tag: 'button',
							className: 'button button-pink button-large',
							onclick: function () {
								D.saveCookies();
							},
							text: D.Lang.get('home.cookies.save')
						}
					]
				}
			]
		}));
		D._cookies.popup.open();
	},

	saveCookies: function () {
		let data = {};
		for (let type in D._cookies.checkboxes) {
			if (!D._cookies.checkboxes.hasOwnProperty(type)) {
				return;
			}
			D.COOKIES[type] = data[type] = D._cookies.checkboxes[type].value();
		}
		new RPC('/api/web_rpc.php').send('saveCookies', data, function () {
			D.reload();
		});
	},

	cookieConsent: function (type, value) {
		if (D.COOKIES[type]) {
			return value;
		}
		let node;
		node = mkE({
			tag: 'div',
			className: 'cookie-consent-iframe',
			els: [
				{
					tag: 'div',
					className: 'content',
					els: [
						{
							tag: 'p',
							text: D.Lang.get('home.cookies.consent.' + type)
						},
						{
							tag: 'div',
							className: 'bottom',
							els: [
								{
									tag: 'button',
									className: 'button button-gray',
									onclick: () => {
										D.enableCookies();
									},
									text: D.Lang.get('home.cookies.consent.agree')
								},
								{
									tag: 'a',
									onclick: () => {
										D.cookiesSettings();
									},
									text: D.Lang.get('home.cookies.consent.settings')
								}
							]
						}
					]
				}
			]
		});
		return node;
	},

	scrollIntoView: function (node, scrollParent, offset) {
		let top;
		if (!isset(offset)) {
			offset = 70;
		}
		if (scrollParent) {
			top = D.position(node, scrollParent).top - offset;
			$(scrollParent).animate({
				scrollTop: top
			});
		}
		top = D.position(node).top - offset;
		$('html, body').animate({
			scrollTop: top
		});
	},

	initDropdownMenu: function () {
		let el = document.querySelector('.main-menu-account');
		if (el) {
			el.addEventListener('mouseover', D.closure(this, D.onDropdownOver, '.main-menu-account', 'bottom'));
			el.addEventListener('mouseout', D.closure(this, D.onDropdownOut, '.main-menu-account'));
		}

		let el2 = document.querySelector('.main-menu-language');
		if (el2) {
			el2.addEventListener('mouseover', D.closure(this, D.onDropdownOver, '.main-menu-language', 'bottom'));
			el2.addEventListener('mouseout', D.closure(this, D.onDropdownOut, '.main-menu-language'));
		}

		let el3 = document.querySelector('.main-menu-about');
		if (el3) {
			el3.addEventListener('mouseover', D.closure(this, D.onDropdownOver, '.main-menu-about', 'bottom'));
			el3.addEventListener('mouseout', D.closure(this, D.onDropdownOut, '.main-menu-about'));
		}
	},

	onDropdownOver: function (selector, position) {
		let windowSize = $(window).width() / parseFloat($("body").css("font-size"));
		if (windowSize < 992 / 14) {
			return;
		}
		let el = document.querySelector(selector);
		if (!el) {
			return;
		}
		let dropdown = document.querySelector(selector + ' > div');
		if (!dropdown) {
			return;
		}
		addClassName(dropdown, 'active');
		el._popper = new Popper(el, dropdown, {
			placement: position
		});
	},

	onDropdownOut: function (selector) {
		let el = document.querySelector(selector);
		if (!el) {
			return;
		}
		let dropdown = document.querySelector(selector + ' > div');
		if (!dropdown) {
			return;
		}
		removeClassName(dropdown, 'active');
		if (el._popper) {
			el._popper.destroy();
		}
	},

	inScreen: function (el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.height > 0 &&
			rect.width > 0 &&
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},

	inScreenAny: function (el ,offset = 0) {
		const rect = el.getBoundingClientRect();
		const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

		return (
			rect.bottom - offset > 0 &&
			rect.top + offset < viewportHeight &&
			rect.right - offset > 0 &&
			rect.left + offset < viewportWidth
		)
	},

	addStats: function (kw) {
		let m = new DR.web.AddStats();
		m.kw = kw;
		m.call();
	},

	CSS: {
		brMobile: false,
		brTablet: false,
		cssBrMobile: false,
		cssBrTablet: false,
		cssBrDesktop: false,
		cssBrWide: false,
		onResize() {
			let baseSize = 16;
			this.brMobile = screen.width < 768;
			this.brTablet = screen.width < 992;
			this.cssBrMobile = window.innerWidth < (baseSize * 41.1428571428);
			this.cssBrTablet = window.innerWidth < (baseSize * 54.8471428571);
			this.cssBrDesktop = window.innerWidth < (baseSize * 70.8471428571);
			this.cssBrWide = window.innerWidth < (baseSize * 92.8571428571);
		}
	},

	async loadGoogleMaps(libraries) {
		if (typeof google === "undefined" || typeof google.maps === "undefined") {
			(g => {
				let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__",
					m = document, b = window;
				b = b[c] || (b[c] = {});
				let d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams,
					u = () => h || (h = new Promise(async (f, n) => {
						await (a = m.createElement("script"));
						e.set("libraries", [...r] + "");
						for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
						e.set("callback", c + ".maps." + q);
						a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
						d[q] = f;
						a.onerror = () => h = n(Error(p + " could not load."));
						a.nonce = m.querySelector("script[nonce]")?.nonce || "";
						m.head.append(a)
					}));
				d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n))
			})({
				key: "AIzaSyAq5TPvce-Ornjbe71qIDVN7YsOWQjNVzk",
				v: "weekly"
			});
		}
		await google.maps.importLibrary('maps');
		if (libraries && libraries.length) {
			for (let i = 0; i < libraries.length; i++) {
				await google.maps.importLibrary(libraries[i]);
			}
		}
	},

	lottie(par) {
		D.addJS('/dist/vendor/lottie/lottie.min.js?v=' + D.v, function() {
			window.lottie.loadAnimation(par);
		});
	},

	MAP_STYLE: [
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f9f5ed"
				},
				{
					"saturation": "0"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f9f5ed"
				}
			]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi.attraction",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi.business",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi.medical",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#fbd3da"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#dbeed0"
				}
			]
		},
		{
			"featureType": "poi.sports_complex",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#fcfcdd"
				},
				{
					"saturation": "0"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#efd151"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#ffffff"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#dcdcdc"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#ffffff"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#d4cdb9"
				}
			]
		},
		{
			"featureType": "transit.station.airport",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#e1e6ea"
				}
			]
		},
		{
			"featureType": "transit.station.airport",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#b5c5d2"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#a2daf2"
				}
			]
		}
	],

	sendPostMessage(data) {
		if (window.Android) {
			window.Android.postMessage(JSON.stringify(data));
		} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
			window.webkit.messageHandlers.iosListener.postMessage(data);
		} else {
			window.postMessage(JSON.stringify(data));
		}
	},

};

D.JSON = window._DJSON;
